import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace("#", ""));
        const session_id = params.get("session_id");
        if (!session_id) {
            navigate("/login");
            return;
        }
        (async () => {
            try {
                await api.post("/auth/google/session", { session_id });
                await checkAuth();
                // If the visitor was mid-onboarding (anonymous funnel), replay
                // the saved answers now that they have an account, then route
                // them through the welcome screen instead of the dashboard.
                const stashedOnboarding = await tryReplayAnonymousOnboarding();
                window.history.replaceState(null, "", stashedOnboarding ? "/welcome" : "/dashboard");
                navigate(stashedOnboarding ? "/welcome" : "/dashboard", { replace: true });
            } catch (e) {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, checkAuth]);

    return (
        <div className="flex h-screen items-center justify-center text-sm uppercase tracking-widest text-muted-foreground" data-testid="auth-callback">
            Signing you in…
        </div>
    );
}

async function tryReplayAnonymousOnboarding() {
    try {
        const raw = localStorage.getItem("hg_onboarding_v1");
        if (!raw) return false;
        const { a } = JSON.parse(raw) || {};
        if (!a || !a.experience) return false;
        const goal = (() => {
            const w = new Set(a.why || []);
            if (w.has("Lose fat / lean out") && (w.has("Build serious muscle") || a.vision === "recomp")) return "recomp";
            if (w.has("Lose fat / lean out")) return "fatloss";
            return "recomp";
        })();
        const split = a.experience === "beginner" || (a.days_per_week || 4) <= 3 ? "full_body" : "upper_lower";
        await api.post("/onboarding", {
            experience: a.experience,
            goal,
            split,
            step_goal: a.step_goal,
            why: a.why,
            pain_points: a.pain_points,
            stuck_duration: a.stuck_duration,
            past_programs: a.past_programs,
            vision: a.vision,
            days_per_week: a.days_per_week,
            minutes_per_session: a.minutes_per_session,
            height_cm: parseFloat(a.height_cm),
            weight_kg: parseFloat(a.weight_kg),
            age: parseInt(a.age),
            sex: a.sex,
            commitment_level: a.commitment_level,
        });
        localStorage.removeItem("hg_onboarding_v1");
        return true;
    } catch {
        return false;
    }
}
